<script>
export default {
  props: {
    soalStats: Object,
    listItem: Object,
    currentQuestion: Object,
    is_instruksi: Number,
    mengerjakan: Function,

    // Jawaban
    // currentQuestion: Object,
    currentQuestionOptionList: Object,
    currentQuestionShuffleOptionList: Object,
    answers: Array,
    currentIndex: Number,
    hasImageOptions: Boolean,
    currentPage: Number,
    selectAnswer: Function,

    // navigasi
    // currentQuestion: Object,
    openProgressFinal: Function,
    nextQuestion: Function,
    // is_instruksi: Number,
    nextSoal: Function,
    last_page: Number,
    index_soal: Number,
    status_pengerjaan: Number,
    // mengerjakan: Function,
  },

  data() {
    return {
      BACKEND_URL: process.env.VUE_APP_BACKEND_URL,
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      abjad : ["A", "B", "C", "D"],
    };
  },

  
};
</script>

<template>
  <div v-if="currentQuestion && index_soal == 0" class="mym-question-body">
    <div class="pt-3 mb-3">
      <!-- <div class="mb-3">
        Jika anda sudah memahami petunjuk, silahkan tekan tombol
        <strong>MULAI MENGERJAKAN</strong>
      </div> -->

      <div
        class="text-center fw-bold"
      >
        <button type="button" class="mym-btn mym-bg-success w-100" @click="nextSoal(0)">
          <i class="fas fa-play me-1"></i>
          MULAI MENGERJAKAN
        </button>
      </div>
    </div>

    <!-- NUMBER -->
    <div class="mym-question-navigation">
      <div class="mym-qn-header">
        <div class="mym-question-number">
          <strong>Instruksi</strong>
        </div>
      </div>

      <div class="mym-question-section">
        <div class="mb-2">
          <div>
            <h4>
              Petunjuk Pilihan Ganda
            </h4>
          </div>

          <div>
            <p>
              Silahkan pilih salah satu jawaban dengan klik pada pilihan jawaban
              yang tersedia.
            </p>
          </div>

          <p>Klik "preview" untuk menampilkan gambar</p>
        </div>

        <div class="mb-3">
          <b>Contoh Soal</b>
          <p>{{ currentQuestion.soal_text }}</p>
        </div>

        <div class="mb-3">
          <div v-if="currentQuestion?.soal_image" class="mym-question-image-wrapper">
            <img
              :src="BACKEND_URL + currentQuestion?.soal_image"
              class="mym-question-image"
            />
          </div>
          <div class="mym-question-text">
            {{ currentQuestion?.pertanyaan }}
          </div>
        </div>
      </div>
    </div>

    <!-- ================= OPTIONS SECTION ================= -->
    <div class="mym-options-section">
      <div class="mym-options" :class="{ 'grid-mode': hasImageOptions }">
        <div
          v-for="(jawaban, i) in currentQuestionShuffleOptionList"
          :key="i"
          class="mym-option-card"
          :class="{ active: jawaban.selected }"
          @click="selectAnswer(currentQuestion, jawaban)"
        >
          <!-- @click="localAnswers[currentIndex] = opt.kode_jawaban" -->

          <img v-if="jawaban.image" :src="jawaban.image" class="option-image" />

          <div class="option-content">
            <div class="option-label">
              <span v-if="jawaban.selected">✔</span>
              <!-- <span v-else>{{ jawaban.kode_jawaban }}</span> -->
               <span v-else>{{ abjad[i] }}</span>
            </div>

            <div class="option-text">
              {{ jawaban.jawaban }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.mym-question-image-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}

.mym-question-image {
  width: 65%;
  height: auto;
}
</style>